module.exports = __webpack_public_path__ + "static/img/nube-tecnologia.7a66d75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clinic/nube-tecnologia.jpg
// module id = w2+0
// module chunks = 0